import Keycloak from 'keycloak-js'
import type { AuthConfig } from '../types/AuthConfig'
import type { Auth } from '../types/Auth'

export default class KeycloakJs implements Auth {
	private keycloak?: Keycloak
	private config?: AuthConfig

	async init(config: AuthConfig) {
		this.config = config
		this.keycloak = new Keycloak({
			url: config.url,
			clientId: config.clientId,
			realm: config.realm,
		})

		await this.keycloak.init({
			onLoad: 'check-sso',
			silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
			checkLoginIframe: false,
			pkceMethod: 'S256',
			responseMode: 'query',
		})

		return {
			accessToken: this.keycloak.token,
			idToken: this.keycloak.idToken,
			refreshToken: this.keycloak.refreshToken,
		}
	}

	async signIn() {
		await this.keycloak?.login()
	}

	async signOut() {
		return this.keycloak?.logout({
			redirectUri: this.config?.redirectUri || window.location.origin,
		})
	}

	async signUp() {
		return this.keycloak?.register()
	}

	async refreshToken() {
		await this.keycloak?.updateToken(-1) // Force refresh
		return {
			accessToken: this.keycloak?.token,
			idToken: this.keycloak?.idToken,
			refreshToken: this.keycloak?.refreshToken,
		}
	}
}
